import { authSlice } from './auth.reducer';

export const { SET_ERROR_MSG, SET_AUTH_USERID, SET_AUTH_JWT, SET_ACCESS_TYPE, RESET_AUTH_STATE } =
  authSlice.actions;
